import { render, staticRenderFns } from "./BalanceWithdrawRecharge.vue?vue&type=template&id=390f9d28&scoped=true"
import script from "./BalanceWithdrawRecharge.vue?vue&type=script&lang=js"
export * from "./BalanceWithdrawRecharge.vue?vue&type=script&lang=js"
import style0 from "./BalanceWithdrawRecharge.vue?vue&type=style&index=0&id=390f9d28&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390f9d28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390f9d28')) {
      api.createRecord('390f9d28', component.options)
    } else {
      api.reload('390f9d28', component.options)
    }
    module.hot.accept("./BalanceWithdrawRecharge.vue?vue&type=template&id=390f9d28&scoped=true", function () {
      api.rerender('390f9d28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/financials-agent/components/Balance/BalanceWithdrawRecharge.vue"
export default component.exports